import { formatMoney } from '../../shared/format/public-api';

/** Prefill cost from last purchase. Null/missing → empty. Do not invent 0. */
export function lastUnitCostPrefill(lastCost: number | null | undefined): string {
  if (lastCost == null || !Number.isFinite(lastCost)) return '';
  return String(lastCost);
}

/** Only a bare integer counts. "contado", "30 días", "30 días f.f." → null. */
export function parsePaymentTermsDays(paymentTerms: string | null | undefined): number | null {
  if (paymentTerms == null) return null;
  const trimmed = paymentTerms.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  return Number(trimmed);
}

export function addIsoDays(isoDate: string, days: number): string {
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  const date = new Date(y, (m ?? 1) - 1, d ?? 1);
  date.setDate(date.getDate() + days);
  const yy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

export function todayLocalIsoDate(now = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function dueDateFromPaymentTerms(
  paymentTerms: string | null | undefined,
  fromIsoDate: string,
): string | null {
  const days = parsePaymentTermsDays(paymentTerms);
  if (days == null) return null;
  return addIsoDays(fromIsoDate, days);
}

export function expectedDeliveryFromLeadTime(
  leadTimeDays: number | null | undefined,
  todayIso: string,
): string | null {
  if (leadTimeDays == null || !Number.isFinite(leadTimeDays) || leadTimeDays < 0) return null;
  return addIsoDays(todayIso, Math.trunc(leadTimeDays));
}

export function minOrderBelowWarning(
  minimumOrderAmount: number | null | undefined,
  currentTotal: number,
): string | null {
  if (minimumOrderAmount == null || !(minimumOrderAmount > 0)) return null;
  if (currentTotal >= minimumOrderAmount) return null;
  return `El mínimo de este proveedor es ${formatMoney(minimumOrderAmount)}. Este pedido va por debajo.`;
}

export function normalizeInvoiceRef(ref: string | null | undefined): string {
  return (ref ?? '').trim().toLowerCase();
}

export function hasDuplicateSupplierInvoiceRef(params: {
  invoiceRef: string;
  otherRefs: Array<{ orderId: string; supplierInvoiceRef: string | null }>;
  excludeOrderId?: string | null;
}): boolean {
  const candidate = normalizeInvoiceRef(params.invoiceRef);
  if (!candidate) return false;
  return params.otherRefs.some(
    (row) =>
      row.orderId !== params.excludeOrderId &&
      normalizeInvoiceRef(row.supplierInvoiceRef) === candidate,
  );
}
